export default function anchorNavigation(navEl: HTMLElement) {
    const navLinks = Array.from(navEl.querySelectorAll('a[href^="#"]')) as HTMLAnchorElement[];
    let activeSection: string | null = null;
    let frameRequested = false;

    if (navLinks.length === 0) return;

    const sections = navLinks.map(link => {
        const href = link.getAttribute('href');
        if (href === '#') return null;
        return document.querySelector(href);
    }).filter(section => section !== null) as HTMLElement[];

    if (sections.length === 0) return;

    const updateActiveNavItems = () => {
        navLinks.forEach(link => {
            const href = link.getAttribute('href');
            if (!href) return;

            const sectionId = href.replace('#', '');
            link.classList.toggle('active', sectionId === activeSection);
        });
    };

    // The activation line sits just below the sticky nav. It is measured on every
    // update so it tracks the main nav clearance and the nav's sticky/non-sticky height.
    const getActivationLine = () => navEl.getBoundingClientRect().bottom + 10;

    const isScrolledToBottom = () => {
        const doc = document.documentElement;
        return Math.ceil(window.innerHeight + window.scrollY) >= doc.scrollHeight - 2;
    };

    const getCurrentSection = (): HTMLElement => {
        // If the page can't scroll any further, the last section is the one the user is
        // looking at even if its top never reaches the activation line.
        if (isScrolledToBottom()) {
            return sections[sections.length - 1];
        }

        const activationLine = getActivationLine();
        let current = sections[0];

        // The current section is the last one whose top has scrolled past the activation
        // line. There is always a current section, so the active state never falls back
        // to the first link while scrolling through the gap between two sections.
        sections.forEach(section => {
            if (section.getBoundingClientRect().top <= activationLine) {
                current = section;
            }
        });

        return current;
    };

    const update = () => {
        frameRequested = false;
        activeSection = getCurrentSection().id;
        updateActiveNavItems();
    };

    const requestUpdate = () => {
        if (frameRequested) return;
        frameRequested = true;
        window.requestAnimationFrame(update);
    };

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);

    navLinks.forEach(link => {
        link.addEventListener('click', () => {
            const href = link.getAttribute('href');
            if (!href) return;

            // Highlight the clicked link immediately; the scroll handler settles the
            // final state once the jump completes.
            activeSection = href.replace('#', '');
            updateActiveNavItems();
        });
    });

    update();
}
